/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAskOracle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17.111 11.997a2.757 2.757 0 0 1-2.75 2.762H9.639a2.757 2.757 0 0 1-2.752-2.762A2.756 2.756 0 0 1 9.64 9.238h4.722a2.756 2.756 0 0 1 2.75 2.759z" />
        <path d="M24 0H0v24h24zM5.28 11.997a4.255 4.255 0 0 1 4.25-4.262h4.94a4.254 4.254 0 0 1 4.248 4.262c0 2.36-1.902 4.269-4.249 4.269l-4.939-.002a4.259 4.259 0 0 1-4.25-4.267z" />
      </g>
    </g>
  </Icon>
);
export { SvgAskOracle as AskOracle };
